import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const CharityDonationSection = styled(Box)`
  width: 100%;
  padding-top: 130px;
  position: relative;
`;

export const TextPairBox = styled(Box)`
  width: 100%;
  top: 160px;
  ${themeMediaQuery('below_sm')} {
    position: unset;
  }
  ${themeMediaQuery('sm')} {
    position: unset;
  }
  ${themeMediaQuery('md')} {
    position: absolute;
  }
  ${themeMediaQuery('xl')} {
    top: 180px;
  }
`;

export const CharityTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 350px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 400px;
    }
  }
`;

export const DogImage = styled(CloudImage)`
  width: 100%;
  object-fit: contain;
  max-height: 643px;
  ${themeMediaQuery('xl')} {
    max-height: 760px;
  }
`;

export const StyledTextColumn = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;
